import { all, call, select, put, takeLatest } from 'redux-saga/effects';
import { getPackagesWithTeamid, getPackagesSearchWithTeamid } from '../../../api/cloudApiGenerated';
import actionTypes from '../../../redux/actions/action-types';
import { setAction } from '../actions/packagesPage';

export type GenericPayload = {
  type: string;
};

type loadPackageProjectPayload = GenericPayload & {
  data: {
    uuid: string;
  };
};

export function* getTeamPackages(): any {
  const { team } = yield select((state) => state.profile);
  try {
    const data = yield call(getPackagesWithTeamid, team.id);
    yield put(
      setAction({
        packages: data
      })
    );
  } catch (e) {
    console.log(e);
  }
}

export function* searchTeamPackages(params: any): any {
  const { query } = params.data;
  const { team } = yield select((state) => state.profile);
  try {
    const data = yield call(getPackagesSearchWithTeamid, team.id, query);
    yield put(
      setAction({
        packages: data
      })
    );
  } catch (e) {
    console.log(e);
  }
}

/** Watch functions */
export function* watchGetTeamPackages() {
  yield takeLatest(actionTypes.packagesPage.getTeamPackages, getTeamPackages);
}

export function* watchSearchTeamPackages() {
  yield takeLatest(actionTypes.packagesPage.searchTeamPackages, searchTeamPackages);
}

export default function* rootSaga() {
  yield all([watchGetTeamPackages(), watchSearchTeamPackages()]);
}
